import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'

import { extendTheme } from '@chakra-ui/react'
import { withFlagFont } from '../flagFont'
import { colors } from './colors'
import { cardTheme } from './card'
import { buttonTheme } from './button'
import { checkboxTheme } from './checkbox'
import { fieldTheme, inputTheme } from './input'
import { linkTheme } from './link'
import { radioTheme } from './radio'

export const theme = extendTheme({
	styles: {
		global: {
			body: {
				'.grecaptcha-badge': {
					visibility: 'hidden!important',
				},
			},
		},
	},
	fonts: {
		// Tahoma is fallback for Arabic
		heading: withFlagFont(`'Inter', 'Tahoma', sans-serif`),
		body: withFlagFont(`'Inter', 'Tahoma', sans-serif`),
	},
	colors,
	components: {
		Button: buttonTheme,
		Card: cardTheme,
		Checkbox: checkboxTheme,
		Form: {
			baseStyle: {
				container: {
					label: {
						fontSize: 'sm',
						fontWeight: 'semibold',
						color: 'gray.800',
					},
				},
			},
		},
		Heading: {
			baseStyle: {
				fontWeight: 'semibold',
				color: 'primary.800',
				letterSpacing: 'tight',
				lineHeight: '1.2',
			},
		},
		Input: inputTheme,
		Link: linkTheme,
		// Chakra hardcodes the light menu surface as '#fff' — the one place its
		// component themes skip the palette. The token renders the same white,
		// and follows the form dark palette (lib/formDarkPalette.ts).
		Menu: {
			baseStyle: {
				list: { '--menu-bg': 'colors.white' },
			},
		},
		PinInput: {
			variants: {
				outline: fieldTheme,
			},
		},
		Progress: {
			defaultProps: {
				colorScheme: 'primary',
				sx: {
					'& > div:first-child': {
						transitionProperty: 'width',
					},
				},
			},
		},
		Radio: radioTheme,
		Select: inputTheme,
		Table: {
			variants: {
				simple: {
					th: {
						py: 2,
					},
					td: {
						py: 2,
					},
				},
			},
		},
		Textarea: {
			variants: {
				outline: fieldTheme,
			},
		},
	},
	sizes: {
		md: 9,
	},
})
